import Vue from "vue";
import Vuex from "vuex";
import User from "@/shared/lib/client-sdk/models/user";
import $ from "jquery";
import SystemPropertiesModule from "@/shared/store/modules/system-properties.js";
import nliraCustomBranding from "@/shared/store/modules/nlira-custom-branding.js";
import lead from "./lead";

Vue.use(Vuex);

/**
 * Auto Branding Plugin
 *
 * Automatically manages custom branding based on user authentication changes
 * Listens for user mutations and triggers appropriate branding actions
 */
const autoBrandingPlugin = (store) => {
  store.subscribe(async (mutation, state) => {
    // Auto-fetch branding when user is set or removed
    if (
      mutation.type === "setAuthenticatedUser" ||
      mutation.type === "removeAuthenticatedUser"
    ) {
      try {
        await store.dispatch("nliraCustomBranding/fetchEffectiveCustomBrand");
      } finally {
        // Signal that branding is done loading
        store.commit("isLoadingAuthenticatedUser", false);
      }
    }
  });
};

export default new Vuex.Store({
  state: {
    authenticatedUser: null,
    isLoadingAuthenticatedUser: true,
  },
  mutations: {
    setAuthenticatedUser(state, user) {
      state.authenticatedUser = user;
    },
    removeAuthenticatedUser(state) {
      state.authenticatedUser = null;
    },
    isLoadingAuthenticatedUser(state, loading) {
      state.isLoadingAuthenticatedUser = loading;
    },
  },
  actions: {
    refreshAuthenticatedUser({ commit, dispatch }, callback) {
      commit("isLoadingAuthenticatedUser", true);

      User.fetchAuthenticatedUser(
        async function (user) {
          // Set the authenticated user in state (this triggers branding fetch via plugin)
          if (!user) {
            commit("removeAuthenticatedUser");
          } else {
            commit("setAuthenticatedUser", user);
          }
          // The plugin will set isLoadingAuthenticatedUser to false when branding is done
          commit("isLoadingAuthenticatedUser", false);

          if ($.isFunction(callback)) callback(user);
        }.bind(this)
      );
    },
  },
  modules: {
    systemProperties: SystemPropertiesModule,
    nliraCustomBranding,
    lead,
  },
  plugins: [autoBrandingPlugin],
});
